import { useState, type MouseEvent } from 'react';
import APILink from "@/components/shared/api-link";
import { Download } from 'lucide-react';
import { useSelectedContract } from '@/hooks/api/use-contracts';
import { useWhitelabel } from '@/hooks/api/use-whitelabel';
import { getActionBlockedReason, isActionAvailable } from '@/lib/contracts';
import { PDF } from '@/types/api/endpoints';

const AvisEcheance = () => {
    const contract = useSelectedContract();
    const avisEcheanceLink = contract && isActionAvailable(contract, 'telecharger_avis_echeance') ? PDF.avisEcheance(contract.id) : null;
    const avisEcheanceReason = getActionBlockedReason(contract, 'telecharger_avis_echeance');
    const emailGestion = useWhitelabel().data?.email_gestion;
    const [disabled, setDisabled] = useState(false)

    const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
        if (disabled) {
            return e.preventDefault()
        }
        setDisabled(true)
    }

    if (avisEcheanceLink !== null) {
        return (
            <div className="text-center">
                <p className="text-sm mb-4">Pour télécharger votre document cliquez sur le bouton ci-dessous :</p>
                <APILink
                    href={avisEcheanceLink as string}
                    target="_blank"
                    onClick={(e) => handleClick(e)}
                    className={`inline-flex items-center gap-2 px-6 py-2 text-sm font-medium rounded-md bg-primary text-white hover:bg-primary-hover transition-all duration-300 ease-in-out cursor-pointer no-underline ${disabled && 'opacity-50 pointer-events-none'}`}
                    download
                >
                    <Download className="w-4 h-4" />
                    Télécharger mon avis d'échéance
                </APILink>
            </div>
        )
    } else {
        return (
            <div className="text-sm">
                <p>Votre contrat ne permet pas l'édition d'un avis d'échéance en ligne pour le motif suivant : <strong>{avisEcheanceReason}</strong></p>
                <p>Vous pouvez contacter le service client à <a href={`mailto:${emailGestion}`} className="text-primary hover:underline">{emailGestion}</a></p>
            </div>
        )
    }
};

export default AvisEcheance;
